export const configDaily = [
    { name: "name", label: "Nama\nCabang", options: { sort: false } },
    { name: "newProspect", label: "New\nProspek", options: { sort: false } },
    { name: "newProspectRate", label: "Rate\n%", options: { sort: false } },
    { name: "nonFU", label: "Non\nFU", options: { sort: false } },
    { name: "nonFURate", label: "Rate\n%", options: { sort: false } },
    { name: "ongoing", label: "On\nGoing", options: { sort: false } },
    { name: "ongoingRate", label: "Rate\n%", options: { sort: false } },
    { name: "pending", label: "Pending", options: { sort: false } },
    { name: "pendingRate", label: "Rate\n%", options: { sort: false } },
    { name: "deal", label: "Deal", options: { sort: false } },
    { name: "dealRate", label: "Rate\n%", options: { sort: false } },
    { name: "drop", label: "Drop", options: { sort: false } },
    { name: "dropRate", label: "Rate\n%", options: { sort: false } },
];

export const configMonitoring = [
    { name: "namaCabang", label: "Nama\nCabang", options: { sort: false } },
    { name: "roH1", label: "RO\nH1", options: { sort: false } },
    { name: "roH1Rate", label: "Rate\n%", options: { sort: false } },
    { name: "roH23", label: "RO\nH23", options: { sort: false } },
    { name: "roH23Rate", label: "Rate\n%", options: { sort: false } },
    { name: "xsh21", label: "XS\nH21", options: { sort: false } },
    { name: "xsh21Rate", label: "Rate\n%", options: { sort: false } },
    { name: "xsh21P", label: "XS\nH21P", options: { sort: false } },
    { name: "xsh21PRate", label: "Rate\n%", options: { sort: false } },
];

export const configYearToDate = [
    {name: 'jan', label: "JAN", options: {sort: false}},
    { name: "janRate", label: "Rate\n%", options: { sort: false } },
    {name: 'feb', label: "FEB", options: {sort: false}},
    { name: "febRate", label: "Rate\n%", options: { sort: false } },
    {name: 'mar', label: "MAR", options: {sort: false}},
    { name: "marRate", label: "Rate\n%", options: { sort: false } },
    {name: 'apr', label: "APR", options: {sort: false}},
    { name: "aprRate", label: "Rate\n%", options: { sort: false } },
    {name: 'mei', label: "MAY", options: {sort: false}},
    { name: "meiRate", label: "Rate\n%", options: { sort: false } },
    {name: 'jun', label: "JUN", options: {sort: false}},
    { name: "junRate", label: "Rate\n%", options: { sort: false } },
    {name: 'jul', label: "JUL", options: {sort: false}},
    { name: "julRate", label: "Rate\n%", options: { sort: false } },
    {name: 'agu', label: "AUG", options: {sort: false}},
    { name: "aguRate", label: "Rate\n%", options: { sort: false } },
    {name: 'sep', label: "SEP", options: {sort: false}},
    { name: "sepRate", label: "Rate\n%", options: { sort: false } },
    {name: 'okt', label: "OCT", options: {sort: false}},
    { name: "oktRate", label: "Rate\n%", options: { sort: false } },
    {name: 'nov', label: "NOV", options: {sort: false}},
    { name: "novRate", label: "Rate\n%", options: { sort: false } },
    {name: 'dec', label: "DEC", options: {sort: false}},
    { name: "decRate", label: "Rate\n%", options: { sort: false } },
];

export const SAMPLE_DATA = [
    {
        name: "Cabang 1",
        roH1: 65,
        roH1Rate: "14%",
        roH23: 14,
        roH23Rate: "31%",
        xsH21: 14,
        xsH21Rate: "33%",
        xsH21p: 55,
        xsH21pRate: "24%",
    },
    {
        name: "Cabang 2",
        roH1: 54,
        roH1Rate: "14%",
        roH23: 90,
        roH23Rate: "31%",
        xsH21: 22,
        xsH21Rate: "33%",
        xsH21p: 55,
        xsH21pRate: "24%",
    },
]
